/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Toast_Customer_Debt_Adjust_SuccessInputs */

const vi_toast_customer_debt_adjust_success = /** @type {(inputs: Toast_Customer_Debt_Adjust_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Điều chỉnh công nợ thành công`)
};

/**

* @param {Toast_Customer_Debt_Adjust_SuccessInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const toast_customer_debt_adjust_success = /** @type {((inputs?: Toast_Customer_Debt_Adjust_SuccessInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Toast_Customer_Debt_Adjust_SuccessInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_toast_customer_debt_adjust_success(inputs)
});